import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, Card, Table } from 'react-bootstrap';
import Flex from '../../common/Flex';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';

const CreditBalance = () => {
  const creditBalances = useSelector((state) => state.creditBalance.data);
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Dropdown
      navbar={true}
      as='li'
      show={isOpen}
      className={'d-none d-sm-none d-md-block d-lg-block'}
      onToggle={handleToggle}
    >
      <Dropdown.Toggle
        bsPrefix='toggle'
        as={Link}
        to='#!'
        className='pe-4 ps-2 nav-link '
      >
        <Flex direction={'column'} justifyContent='center' alignItems={'end'}>
          <h5 className='text-dark fs-0'>Credit Balance</h5>
          <h6 className='text-warning m-0 fs--1'>
            USD 600.00&nbsp;&nbsp;
            <FontAwesomeIcon icon={faCaretDown} size='lg' />
          </h6>
        </Flex>
      </Dropdown.Toggle>

      <Dropdown.Menu className='dropdown-menu-card dropdown-menu-end dropdown-caret dropdown-caret-bg'>
        <Card className='dropdown-menu-end shadow-none' style={{ width: 380 }}>
          <Card.Header>
            <Card.Title>Credit Balance</Card.Title>
          </Card.Header>
          <Card.Body className='p-0'>
            <Table responsive hover className='fs--1'>
              <thead>
                <tr className='bg-200'>
                  <th>Payment Ref</th>
                  <th>Time</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {creditBalances.map((value, index) => (
                  <tr key={index}>
                    <td>{value.paymentRef}</td>
                    <td>{value.time}</td>
                    <td>{value.amount}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CreditBalance;
